
import React from 'react';

export const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-16 sm:py-20 bg-white overflow-hidden">
      <div className="container mx-auto px-4 max-w-full">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 break-words">
            お問い合わせ
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed break-words">
            サービスに関するご質問や
            求人に関するお問い合わせなど、
            お気軽にご連絡ください。
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* 連絡先情報 */}
          <div className="space-y-6 sm:space-y-8 min-w-0">
            <div className="bg-pink-50 p-6 sm:p-8 rounded-lg">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 text-center lg:text-left break-words">
                お電話でのお問い合わせ
              </h3>
              <div className="space-y-4">
                <div className="flex items-center min-w-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-pink-100 rounded-full flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-phone-fill text-pink-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-base sm:text-lg text-gray-600 mb-1">電話番号</div>
                    <a href="tel:024-563-7717" className="text-2xl sm:text-3xl font-bold text-pink-600 hover:text-pink-700 whitespace-nowrap">
                      024-563-7717
                    </a>
                  </div>
                </div>
                <div className="flex items-center min-w-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-pink-100 rounded-full flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-time-fill text-pink-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-base sm:text-lg text-gray-600 mb-1">受付時間</div>
                    <div className="text-lg sm:text-xl font-semibold text-gray-800">平日 8:00〜18:00</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-6 sm:p-8 rounded-lg">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 text-center lg:text-left break-words">
                事業所情報
              </h3>
              <div className="space-y-4">
                <div className="flex items-start min-w-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-100 rounded-full flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-building-fill text-gray-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-base sm:text-lg text-gray-600 mb-1">事業所名</div>
                    <div className="text-lg sm:text-xl font-semibold text-gray-800 break-words">訪問介護のんな福島</div>
                  </div>
                </div>
                <div className="flex items-start min-w-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-100 rounded-full flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-map-pin-fill text-gray-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-base sm:text-lg text-gray-600 mb-1">所在地</div>
                    <div className="text-lg sm:text-xl font-semibold text-gray-800 leading-relaxed break-all">
                      〒960-8055<br />
                      福島県福島市野田町7-13-50-2階
                    </div>
                  </div>
                </div>
                <div className="flex items-start min-w-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-100 rounded-full flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-organization-chart text-gray-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-base sm:text-lg text-gray-600 mb-1">運営会社</div>
                    <div className="text-lg sm:text-xl font-semibold text-gray-800 break-words">株式会社りえぞん</div>
                  </div>
                </div>
                <div className="flex items-start min-w-0">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-100 rounded-full flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-id-card-fill text-gray-600 text-xl sm:text-2xl"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-base sm:text-lg text-gray-600 mb-1">介護事業所番号</div>
                    <div className="text-lg sm:text-xl font-semibold text-gray-800">770106425</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 p-6 sm:p-8 rounded-lg">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-800 mb-3 sm:mb-4 text-center lg:text-left break-words">アクセス</h3>
            <div className="text-sm sm:text-base text-gray-700 leading-relaxed mb-4 sm:mb-6 break-words">
              <p className="mb-2">
                福島駅西口から福島吾妻裏磐梯線（県道70号線）を北へ進み、
                庭坂街道・八島田街道（県道310号線）を西へ進み、
              </p>
              <p className="mb-2">
                二つ目の信号の先を右折
                （ドコモショップ福島野田店さんがある場所）し直進。
              </p>
              <p>
                進行方向に向かって右手にクスリのアオキさんがある向かい側、
                日野屋楽器店さん2階です。
              </p>
            </div>
            
            {/* Google Map */}
            <div className="w-full h-48 sm:h-64 rounded-lg overflow-hidden border-2 border-gray-200 mb-3 sm:mb-4 max-w-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3144.123456789!2d140.4667!3d37.7667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQ2JzAwLjEiTiAxNDDCsDI4JzAwLjEiRQ!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp&q=福島県福島市野田町7-13-50"
                width="100%"
                height="100%"
                style={{ border: 0, maxWidth: '100%' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="訪問介護のんな福島の所在地"
              />
            </div>
            
            <div className="text-center">
              <a 
                href="https://maps.google.com/?q=福島県福島市野田町7-13-50"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap text-sm sm:text-base"
              >
                <i className="ri-map-pin-line text-base sm:text-lg mr-2"></i>
                Googleマップで開く
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
